import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';
import { Patient as WaitlistPatient } from '@dreryk/egabinet-waitlist-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { appendTestableElementAttributes, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { StyledPatientFieldItemDetails, StyledPatientFieldItemName } from './PatientFieldItem.styled';
import { getPatientDetails } from './PatientFieldItem.utils';

type PatientFieldItemProps = {
   readonly patient: PatientSimple | WaitlistPatient;
};

export const PatientFieldItem = (props: PatientFieldItemProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <div {...appendTestableElementAttributes(String(props.patient.id))}>
         <StyledPatientFieldItemName {...appendTestableElementAttributes('name')}>
            <TextSeparator separator={TextSeparatorType.SPACE}>
               {props.patient.lastName ? <Text testId={'lastName'}>{props.patient.lastName?.asString()}</Text> : null}
               {props.patient.firstName ? (
                  <Text testId={'firstName'}>{props.patient.firstName?.asString()}</Text>
               ) : null}
            </TextSeparator>
         </StyledPatientFieldItemName>
         <StyledPatientFieldItemDetails {...appendTestableElementAttributes('details')}>
            {getPatientDetails(props.patient, translate)}
         </StyledPatientFieldItemDetails>
      </div>
   );
};
